import { Flows } from '~src/flow/resources/Flows';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { setOwner } from '../../../actions/SetOwnerAction';
import { ISetOwnerAction } from '../../../models/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource, anyItemIsUnpublishedWorkbook, isFlow, userCanChangeFlowOwner, userCanManageAlerts} from './IEntityActionHelpers';

export const SetOwnerAction: IEntityAction<IContentInfo, ISetOwnerAction> = {
  name: EntityActionNames.SetOwner,
  translateName: Messages.changeOwner_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: ISetOwnerAction, targetItems: IContentInfo[], state: AppState) => {
    if (anyItemIsUnpublishedWorkbook(targetItems)) {
      return false;
    }

    if (isFlow(state) && Flows.canChangeOwner())
    {
      return !!(availableActions && availableActions.setOwner) || userCanChangeFlowOwner(state);
    }

    return !!(availableActions && availableActions.setOwner) || userCanManageAlerts(state, targetItems);
  },
  createReduxAction: (targetItems: IContentInfo[]) => setOwner(targetItems)
};
